// extracted by mini-css-extract-plugin
export default {"clickableDivider":"NewRowBetween_clickableDivider__apTxk","newButton":"NewRowBetween_newButton__4fkzn","dividerLine":"NewRowBetween_dividerLine__tFFAF"};